import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';
import ThemeToggle from "../../ThemeToggle";

const drawerVariants = {
    hidden: { x: '100%' },
    visible: { x: 0, transition: { type: 'spring', stiffness: 300, damping: 30 } }
};

const Drawer = ({ isOpen, onClose, children }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop to close the drawer when clicked */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black z-40"
          />

          {/* Drawer container */}
          <motion.div
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={drawerVariants}
            transition={{ duration: 0.3 }}
            className="fixed top-0 right-0 w-4/5 max-w-xs h-full bg-white z-50 shadow-xl flex flex-col"
          >
            {/* Close button inside the drawer */}
            <div className="flex p-3 pt-6 justify-between bg-white dark:bg-gray-800">                
              <ThemeToggle />
              <button
                onClick={onClose}
                className="focus:outline-none p-2"
              >
                <FaTimes className="text-gray-800 dark:text-gray-200" size={32}/>
              </button>
            </div>
            <div className="bg-white dark:bg-gray-800">
                <hr className="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700"/>
            </div>
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Drawer;